import { render, staticRenderFns } from "./OcrIndicator.vue?vue&type=template&id=282ef1d7&scoped=true&"
import script from "./OcrIndicator.vue?vue&type=script&lang=js&"
export * from "./OcrIndicator.vue?vue&type=script&lang=js&"
import style0 from "./OcrIndicator.vue?vue&type=style&index=0&id=282ef1d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ef1d7",
  null
  
)

component.options.__file = "OcrIndicator.vue"
export default component.exports